<template>
  <v-container
    id="login"
    class="fill-height justify-center"
    tag="section"
  >
    <v-row justify="center">
      <v-slide-y-transition appear>
        <base-material-card color="gold" light max-width="100%" width="400" class="px-5 py-3">
          <template v-slot:heading>
            <div class="text-center">
              <h1 class="display-2 font-weight-bold mb-2">
                Cambio de contraseña
              </h1>
            </div>
          </template>
          <v-card-text class="text-center">
            <v-form @submit.prevent="changePass">
              <v-text-field
                v-model="email"
                color="secondary"
                label="Email"
                prepend-icon="mdi-email"
              />
              <v-text-field
                v-model="password"
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="[rules.required, rules.max]"
                :type="show1 ? 'text' : 'password'"
                color="secondary"
                label="Contraseña..."
                hint="At least 8 characters"
                prepend-icon="mdi-lock-outline"
                @click:append="show1 = !show1"
              />
              <v-text-field
                v-model="password_confirmation"
                :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="[rules.required, rules.max]"
                :type="show2 ? 'text' : 'password'"
                class="mb-8"
                color="secondary"
                label="Repita su contraseña..."
                hint="At least 8 characters"
                prepend-icon="mdi-lock-outline"
                @click:append="show2 = !show2"
              />
              <div>
                <v-btn elevation="1" color="gold" class="ma-1" type="submit">
                  Cambiar contraseña
                </v-btn>
              </div>
            </v-form>
          </v-card-text>
        </base-material-card>
      </v-slide-y-transition>
    </v-row>
  </v-container>
</template>

<script>
  // import axios from 'axios'

  export default {
    name: 'PagesChangePass',
    props: {
      resetToken: {
        type: String,
        required: true,
      },
    },
    data: () => ({
      color: 'success',
      message: '',
      show1: false,
      show2: false,
      email: null,
      password: '',
      password_confirmation: '',
      miArray: [],
      // token: this.$route.params.resetToken,
      error: null,
      rules: {
        required: value => !!value || 'Required.',
        max: v => v.length <= 45 || 'Max 45 characters',
        emailMatch: () => ('The email and password you entered don\'t match'),
      },
    }),
    methods: {
      changePass: async function () {
        await this.$http.post('/api/reset-password',
                              {
                                email: this.email,
                                password: this.password,
                                password_confirmation: this.password_confirmation,
                                token: this.resetToken,
                              },
        ).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Cambio realizado con exito.'] })
          this.$router.push({ name: 'login' })
        }).catch(error => {
          if (error.response.data.errors) {
            this.$store.commit('toast/show', { tipo: 'error', messages: error.response.data.errors })
          } else {
            this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
          }
        })
      },
    },
  }
</script>
